export const REMINDERS_TABLE_HEADERS = ["Name", "Timer", "Actions"];

export const REMINDERS_TABLE_ACTIONS = {
    EDIT_REMINDER: "EDIT_REMINDER",
    DELETE_REMINDER: "DELETE_REMINDER",
    CREATE_REMINDER: "CREATE_REMINDER",
};
